import InnerPageHero from "../common/InnerPageHero"
import BannerImage from "../../assets/images/whatwedo-banner.png";
import Contactform from '../home/hooks/Contactform';
import "./contact.css"
import Meta from "../Meta";
export default function Contact() {
    return(
       <>
       <Meta title={"Contact us"} />
        <InnerPageHero title={"Contact Us"} bgImage={BannerImage} />
        <div className="contact-page">
         <Contactform />
        </div>
       </>
    )
}